
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.3 2h-5.6c-.937 0-1.7.763-1.7 1.7v5.6c0 .937.763 1.7 1.7 1.7h5.6c.937 0 1.7-.763 1.7-1.7V3.7c0-.937-.763-1.7-1.7-1.7zM20.3 13h-5.6c-.937 0-1.7.763-1.7 1.7v5.6c0 .937.763 1.7 1.7 1.7h5.6c.937 0 1.7-.763 1.7-1.7v-5.6c0-.937-.763-1.7-1.7-1.7zM9.3 13H3.7c-.937 0-1.7.763-1.7 1.7v5.6c0 .937.763 1.7 1.7 1.7h5.6c.937 0 1.7-.763 1.7-1.7v-5.6c0-.937-.763-1.7-1.7-1.7zM9.3 2H3.7C2.763 2 2 2.763 2 3.7v5.6c0 .937.763 1.7 1.7 1.7h5.6c.937 0 1.7-.763 1.7-1.7V3.7c0-.937-.763-1.7-1.7-1.7z","fill":"#282E3E"}})])
          )
        }
      }
    